import {Component} from "@angular/core";
import * as _ from 'lodash';

@Component({
    selector: 'app-studio-ads',
    templateUrl: './studio-ads.component.html',
    styleUrls: ['./studio-ads.component.scss']
})

export class StudioAdsComponent {
    color = 'blue';
    colors = [
        '#00A878',
        '#D8F1A0',
        '#F3C178',
        '#FE5E41',
        '#EE9B00',
        '#9A8C98',
        '#FAEDCD',
        '#84A59D',
        '#598392',
        '#E9FF70',
        '#86BBD8',
        '#C38E70',
        '#BCB8B1',
        '#F4D58D',
        '#B2F7EF',
        '#CDC1FF',
        '#785C51'
    ];
    message = '';
    msg = [
        "DigitalSignage.com | FREE Digital Signage for EVERYONE!",
        "Digital Signage that's fun and powerful",
        "Watch your business shine with Digital Signage",
        "We've been providing the world's most popular best Digital Signage since 2018",
        "Digital Signage is a must for every business, we make it easy and fun",
        "Elevate your brand, engage your audience and make a lasting impression",
        "Connect with your audience in real-time",
        "Get noticed with dynamic Digital Signage",
        "Maximize your message with Digital Signage",
        "Engage customers with vibrant Digital Signage",
        "Experience the power of Digital Signage today",
        "Enhance your business with modern technology",
        "Catch your customers' attention with Digital Signage",
        "Make a lasting impression with dynamic signage",
        "Stay ahead of the game with Digital Signage",
        "Boost your brand with eye-catching Digital Signage",
        "Transform your space with Digital Signage",
        "Digital Signage - the future of advertising",
        "Communicate your message with ease",
        "Stand out from the competition with Digital Signage",
        "Create an immersive experience with Digital Signage",
        "Innovative technology at your fingertips",
        "Increase sales and engagement with Digital Signage",
        "Dynamic signage for a dynamic world",
        "Elevate your brand with Digital Signage",
        "Inform, entertain, and captivate your audience with Digital Signage",
        "Upgrade your message with Digital Signage",
        "Digital Signage - the smart choice for modern businesses",
        "Get your message across with dynamic Digital Signage",
        "Revolutionize your communication with Digital Signage",
        "Dynamic Digital Signage - the perfect solution for any space",
        "Say it loud and clear with Digital Signage",
        "Digital Signage - the key to effective communication",
        "Make an impact with vibrant Digital Signage",
        "Digital Signage - the ultimate marketing tool",
        "Interactive Digital Signage for an immersive experience",
        "Enhance your brand identity with Digital Signage",
        "Digital Signage: The future of advertising is here",
        "Take your message to the next level with Digital Signage",
        "Revamp your business with innovative Digital Signage",
        "Digital Signage: The way to reach your audience",
        "Create an engaging environment with Digital Signage",
        "Transform your space into a dynamic experience with Digital Signage",
        "Digital Signage - The perfect tool for branding and promotions",
        "Digital Signage: The visual solution to effective communication",
        "Display your message with clarity and precision with Digital Signage",
        "Revolutionize your advertising with Digital Signage",
        "Dynamic Digital Signage for dynamic businesses",
        "Get your message out there with Digital Signage",
        "Digital Signage: The cost-effective solution for advertising",
        "Increase your sales with engaging Digital Signage",
        "Make your brand unforgettable with Digital Signage",
        "Digital Signage: The key to customer engagement",
        "Get noticed with stunning Digital Signage",
        "Digital Signage: The modern way to communicate",
        "Transform your space with the power of Digital Signage",
        "Get noticed with Digital Signage",
        "Elevate your brand with Digital Signage",
        "Create an immersive experience with Digital Signage",
        "Make your message unmissable with Digital Signage",
        "Bring your content to life with Digital Signage",
        "Engage your audience with Digital Signage",
        "Make an impact with Digital Signage",
        "Stand out from the crowd with Digital Signage",
        "Attract attention with Digital Signage",
        "Get your message across with Digital Signage",
        "Make a lasting impression with Digital Signage",
        "Communicate effectively with Digital Signage",
        "Enhance your brand image with Digital Signage",
        "Increase sales with Digital Signage",
        "Boost customer engagement with Digital Signage",
        "Create a memorable experience with Digital Signage",
        "Make your message pop with Digital Signage",
        "Drive traffic with Digital Signage",
        "Capture your audience's attention with Digital Signage",
        "Take your communication to the next level with Digital Signage",
        "Inform, educate, and entertain with Digital Signage",
        "Transform your space with Digital Signage",
        "Communicate with impact with Digital Signage",
        "Make a statement with Digital Signage",
        "Be seen and heard with Digital Signage",
        "Connect with your audience with Digital Signage",
        "Create a dynamic experience with Digital Signage",
        "Make your content shine with Digital Signage",
        "Impress your customers with Digital Signage",
        "Draw attention to your message with Digital Signage",
        "Add value to your brand with Digital Signage",
        "Deliver your message with clarity with Digital Signage",
        "Elevate your marketing with Digital Signage",
        "Increase engagement with Digital Signage",
        "Deliver a personalized experience with Digital Signage",
        "Connect with your audience on a deeper level with Digital Signage",
        "Add a wow factor with Digital Signage",
        "Deliver your message in style with Digital Signage",
        "Get your message across in seconds with Digital Signage",
        "Create a buzz with Digital Signage",
        "Make your brand stand out with Digital Signage",
        "Create an interactive experience with Digital Signage",
        "Make your message memorable with Digital Signage",
        "Display your content like never before with Digital Signage",
        "Create a lasting impression with Digital Signage",
        "Increase customer loyalty with Digital Signage",
        "Create a welcoming atmosphere with Digital Signage",
        "Inform and educate with Digital Signage",
        "Get your message in front of the right people with Digital Signage",
        "Boost your business with Digital Signage",
        "Make your space come alive with Digital Signage",
        "Deliver your message with impact with Digital Signage",
        "Get your brand noticed with Digital Signage",
        "Make your message impossible to ignore with Digital Signage",
        "Increase your visibility with Digital Signage",
        "Create an unforgettable experience with Digital Signage",
        "Capture attention with Digital Signage",
        "Enhance your customer experience with Digital Signage",
        "Communicate effectively with Digital Signage",
        "Deliver your message with confidence with Digital Signage",
        "Make your content more engaging with Digital Signage",
        "Add a touch of sophistication with Digital Signage",
        "Make your message stand out with Digital Signage",
        "Increase foot traffic with Digital Signage",
        "Make an impression with Digital Signage",
        "Make your brand shine with Digital Signage",
        "Connect with your customers with Digital Signage",
        "Create a dynamic display with Digital Signage",
        "Make your content visually stunning with Digital Signage",
        "Make your message heard with Digital Signage",
        "Deliver your message with clarity and impact with Digital Signage",
        "Make your space more inviting with Digital Signage",
        "Create an experience that stands out with Digital Signage"
    ];

    constructor() {
        this.color = this.colors[_.random(0, this.colors.length - 1)];
        this.message = this.msg[_.random(0, this.msg.length - 1)];
    }
}


